// Constants
export const REGISTRANT__SETHSFSTART = 'REGISTRANT::REGISTRANT__SETHSFSTART';
export const REGISTRANT__SETVIP = 'REGISTRANT::SETVIP';
export const REGISTRANT__SETADDITIONALBUYER = 'REGISTRANT::SETADDITIONALBUYER';
export const REGISTRANT__SETBCFS = 'REGISTRANT::SETBCFS';
export const REGISTRANT__SETPROFILE = 'REGISTRANT::SETPROFILE';
export const REGISTRANT__SETPERSON = 'REGISTRANT::SETPERSON';
export const REGISTRANT__SETEMAIL = 'REGISTRANT::SETEMAIL';
export const REGISTRANT__CLEARALL = 'REGISTRANT::CLEARALL';

// Actions
export const setHSFStart = (HSFStart) => ({
  type: REGISTRANT__SETHSFSTART,
  HSFStart,
});
export const setVIP = (VIP) => ({
  type: REGISTRANT__SETVIP,
  VIP,
});
export const setADDITIONALBUYER = (ADDITIONALBUYER) => ({
  type: REGISTRANT__SETADDITIONALBUYER,
  ADDITIONALBUYER,
});
export const setBCFS = (BCFS) => ({
  type: REGISTRANT__SETBCFS,
  BCFS,
});
export const setProfile = (profile) => ({
  type: REGISTRANT__SETPROFILE,
  profile,
});
export const setPerson = (person) => ({
  type: REGISTRANT__SETPERSON,
  person,
});

export const setEmail = (email) => ({
  type: REGISTRANT__SETEMAIL,
  email,
});

export const clearAll = () => ({
  type: REGISTRANT__CLEARALL,
});

// Initial State
const initialState = {
  HSFStart :false,
  VIP:false,
  ADDITIONALBUYER:false,
  BCFS: false,
  profile: null,
  person: null,
  email: null,
};

// Reducer
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case REGISTRANT__SETHSFSTART:
      return {
        ...state,
        HSFStart: action.HSFStart,
      };
    case REGISTRANT__SETBCFS:
      return {
        ...state,
        BCFS: action.BCFS,
      };
    case REGISTRANT__SETVIP:
      return {
        ...state,
        VIP: action.VIP,
      };
      case REGISTRANT__SETADDITIONALBUYER:
        return {
          ...state,
          ADDITIONALBUYER: action.ADDITIONALBUYER,
        };
    case REGISTRANT__SETPROFILE:
      return {
        ...state,
        profile: action.profile,
      };
    case REGISTRANT__SETPERSON:
      return {
        ...state,
        person: action.person,
      };
    case REGISTRANT__SETEMAIL:
      return {
        ...state,
        email: action.email,
      };
    case REGISTRANT__CLEARALL:
      return {
        ...state,
        HSFStart :false,
        BCFS: false,
        VIP: false,
        ADDITIONALBUYER: false,
        profile: null,
        person: null,
        email: null,
      };
    default:
      return state;
  }
};
